<div class="payment-overdue-dialog">
  <div class="payment-overdue-header">
    <span class="payment-overdue-icon" aria-hidden="true">
      <mat-icon>warning</mat-icon>
    </span>
    <h2 mat-dialog-title class="payment-overdue-title">Aviso de vencimiento de pago</h2>
  </div>

  <mat-dialog-content class="payment-overdue-body">
    <p>
      El pago de su servicio venció hace <strong>{{ daysText }}</strong>. Si no recibimos la
      confirmación, el acceso a la plataforma podría bloquearse.
    </p>

    @if (contactEmail) {
      <p class="payment-overdue-hint">
        ¿Ya realizó su pago? Envíe su comprobante a
        <a href="mailto:{{ contactEmail }}">{{ contactEmail }}</a> para evitar la suspensión del
        servicio.
      </p>
    } @else {
      <p class="payment-overdue-hint">
        ¿Ya realizó su pago? Contacte a su distribuidor para confirmar su comprobante y evitar la
        suspensión del servicio.
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="payment-overdue-actions">
    <button
      mat-flat-button
      color="warn"
      class="payment-overdue-action"
      [disabled]="!canClose"
      (click)="close()"
    >
      @if (canClose) {
        Entendido
      } @else {
        Espere {{ secondsLeft }} s para cerrar
      }
    </button>
  </mat-dialog-actions>
</div>
